import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { TestArea } from '../../common/test-area';

export interface Configuration {
  API_BASE_URL: string;
  API_TEST_EMBARGO_URL: string;
  API_TEST_PREPROD_URL: string;
  API_TEST_PROD_URL: string;
  APP_PACKAGE_VERSION: string;
  CONFIG_PACKAGE_VERSION: string;
  DEPLOYMENT_TIME: string;

  FEATURE_QUALITY_REPORT_ENABLED: boolean;
}

@Injectable({ providedIn: 'root' })
export class EnvConfigurationService {

  public static configuration: Configuration;

  private readonly configFileLocation = 'assets/config/config.json';
  private configuration$: Observable<Configuration>;

  public static getDynamicTestUrl(testArea = TestArea.BASE): string {
    switch (testArea) {
      case TestArea.EMBARGO: {
        return this.configuration.API_TEST_EMBARGO_URL;
      }
      case TestArea.PREPROD: {
        return this.configuration.API_TEST_PREPROD_URL;
      }
      case TestArea.PROD: {
        return this.configuration.API_TEST_PROD_URL;
      }
      default: {
        return this.configuration.API_BASE_URL;
      }
    }
  }

  constructor(private http: HttpClient) { }

  public load(): Observable<Configuration> {
    if (!this.configuration$) {
      this.configuration$ = this.http
        .get<Configuration>(`${this.configFileLocation}`)
        .pipe(shareReplay(1));
    }
    this.configuration$.subscribe(item => EnvConfigurationService.configuration = item);
    return this.configuration$;
  }

}
